export default "__VITE_ASSET__DIpMzvfH__"